module.exports = __webpack_public_path__ + "static/img/background-login.bcc52a97.jpg";